export const CREATE_PRODUCT_SURFACE = 'CREATE_PRODUCT_SURFACE'
export const GET_LIST_PRODUCT_SURFACE = 'GET_LIST_PRODUCT_SURFACE'
export const DETAIL_PRODUCT_SURFACE = 'DETAIL_PRODUCT_SURFACE'
export const PATCH_PRODUCT_SURFACE = 'PATCH_PRODUCT_SURFACE'
